<template>
  <v-container class="not-found fill-height pa-0" fluid>
    <v-row class="ma-0" justify="center" align="center">
      <v-col cols="12" sm="10" md="8" lg="6" class="text-center">
        <div class="not-found__code" aria-label="404">
          <span class="not-found__digit">4</span>
          <span class="not-found__digit not-found__digit--accent">0</span>
          <span class="not-found__digit">4</span>
        </div>

        <div class="not-found__rule" aria-hidden="true"></div>

        <h1 class="not-found__title text-h5 font-weight-medium mb-2">Page not found</h1>

        <p class="not-found__subtitle text-body-2 text-medium-emphasis mb-8">
          The page you are looking for does not exist or has been moved.
        </p>

        <RouterLink :to="{ name: 'VendorList' }" class="not-found__link">
          <span class="not-found__link-text">Return to vendors</span>
          <span class="not-found__link-arrow" aria-hidden="true">→</span>
        </RouterLink>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import { RouterLink } from 'vue-router';

  export default defineComponent({
    name: 'NotFound',
    components: { RouterLink },
  });
</script>

<style scoped>
  .not-found {
    --vp-orange: #f88d2a;
    --vp-navy: #2d3e52;
    min-height: calc(100vh - 64px);
  }

  .not-found__code {
    font-size: clamp(112px, 20vw, 220px);
    line-height: 1;
    font-weight: 200;
    letter-spacing: -0.05em;
  }

  .not-found__digit {
    color: var(--vp-navy);
  }

  .not-found__digit--accent {
    color: var(--vp-orange);
    margin: 0 0.02em;
  }

  .not-found__rule {
    width: 56px;
    height: 3px;
    margin: 28px auto 24px;
    background: var(--vp-orange);
    border-radius: 2px;
  }

  .not-found__title {
    color: var(--vp-navy);
  }

  .not-found__link {
    display: inline-flex;
    align-items: baseline;
    gap: 8px;
    color: var(--vp-orange);
    font-size: 1rem;
    font-weight: 500;
    text-decoration: none;
  }

  .not-found__link:hover {
    color: var(--vp-navy);
  }
</style>
